if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', class BackInStock extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('.back-in-stock--btn')
      this.dialog = this.querySelector('dialog')
      this.closeBtn = this.dialog.querySelector('.back-in-stock--close-btn')
      this.form = this.querySelector('form')
      this.submitBtn = this.form.querySelector('[type="submit"]')
      this.successMessage = this.dataset.successMessage

      this.button.addEventListener('click', this.showModal.bind(this))
      this.closeBtn.addEventListener('click', this.hideModal.bind(this))
      this.form.addEventListener('submit', this.submit.bind(this))

      this.anchor = document.querySelector('#notify-bis-anchor')

      if (this.dataset.variantAvailable === 'false') {
        this.enable()
      }

      // We intentionally do not listen for any variant change event here.
    }

    enable() {
      if (this.anchor) {
        this.anchor.insertAdjacentElement('afterbegin', this.button)
      }
      this.button.classList.remove('hidden')   
    }

    disable() {
      this.insertAdjacentElement('afterbegin', this.button)
      this.button.classList.add('hidden')
    }

    showModal() {
      this.dialog.showModal()
    }

    hideModal() {
      this.dialog.close()
    }

    submit(event) {
      event.preventDefault()

      const email = this.form.querySelector('#back-in-stock--email').value
      const variantId = this.form.querySelector('#back-in-stock--variant').value

      const payload = {
        email,
        variantId: +variantId,
        market: this.dataset.market === 'us' ? this.dataset.market : 'international'
      }

      this.submitBtn.disabled = true

      fetch('https://services.pw-solutions.de/sternglas/storefront/back-in-stock-subscriptions', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload)
      })
        .then(response => response.text())
        .then(response => {
          console.log('back-in-stock: success', response)
          this.button.innerText = this.successMessage
        })
        .catch(error => {
          console.log('back-in-stock: error', error)
          this.button.innerText = 'Something went wrong... Please try again later.'
        })
        .finally(() => {
          this.form.reset()
          this.button.disabled = true
          this.hideModal()
        })
    }
  });
}